module.exports = __webpack_public_path__ + "static/media/sombra-inferior-capa.872b9c15.svg";